import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, RequireAuth } from "@/lib/auth";
import PublicLayout from "@/components/PublicLayout";
import DoctorLayout from "@/components/DoctorLayout";
import { Home, About, Services, Consultation, Contact, Privacy, Terms } from "@/pages/PublicPages";
import BookPage from "@/pages/Book";
import LookupPage from "@/pages/Lookup";
import DoctorLogin from "@/pages/DoctorLogin";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import DashboardOverview from "@/pages/DoctorOverview";
import AppointmentsPage from "@/pages/DoctorAppointments";
import CalendarPage from "@/pages/DoctorCalendar";
import PatientsPage from "@/pages/DoctorPatients";
import AvailabilityPage from "@/pages/DoctorAvailability";
import SettingsPage from "@/pages/DoctorSettings";

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/consultation" element={<Consultation />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/book" element={<BookPage />} />
              <Route path="/booking/:reference" element={<BookPage />} />
              <Route path="/lookup" element={<LookupPage />} />
            </Route>

            <Route path="/doctor/login" element={<DoctorLogin />} />
            <Route path="/doctor/forgot-password" element={<ForgotPassword />} />
            <Route path="/doctor/reset-password" element={<ResetPassword />} />

            <Route
              path="/doctor"
              element={
                <RequireAuth>
                  <DoctorLayout />
                </RequireAuth>
              }
            >
              <Route index element={<DashboardOverview />} />
              <Route path="appointments" element={<AppointmentsPage />} />
              <Route path="calendar" element={<CalendarPage />} />
              <Route path="patients" element={<PatientsPage />} />
              <Route path="availability" element={<AvailabilityPage />} />
              <Route path="settings" element={<SettingsPage />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
